import React from 'react';
import { useDisclosure } from '@mantine/hooks';
import { Popover } from '@mantine/core';
import { styled } from 'styled-components';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import { textSmallSemiBold } from '@hud/web-components/DesignSystem/Typography';

type HiddenServicesBadgeProps = {
  numHiddenServices: number;
  hiddenServices: string[];
}

export default function HiddenServicesBadge({ numHiddenServices, hiddenServices }: HiddenServicesBadgeProps) {
  const [opened, { close, open }] = useDisclosure(false);


  return (
    <Popover position="bottom" offset={10} withArrow shadow="md" opened={opened}>
      <Popover.Target>
          <span className="serviceCounter"
                onMouseEnter={open}
                onMouseLeave={close}>+ {numHiddenServices}</span>
      </Popover.Target>
      <PopoverDropdownContainer>
        <ul>
          {
            hiddenServices.map((service, index) => (
              <li key={index}><HudIcon icon="designSystem.service" /> {service}</li>
            ))
          }
        </ul>
      </PopoverDropdownContainer>
    </Popover>
  );
}

const PopoverDropdownContainer = styled(Popover.Dropdown)`
  background: var(--black-400);
  border-color: var(--border-color-default);
  padding: var(--space-150);
  border-radius: 8px;

  ul {
    margin: 0;
    list-style-type: none;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      gap: var(--space-50);
      padding: 0;
      margin: var(--space-100) 0;
      ${textSmallSemiBold};
      color: var(--text-standard-secondary);

      &:first-child, &:last-child {
        margin: 0;
      }

      svg path {
        stroke: var(--text-standard-secondary);
      }
    }
  }
`;
